import { render, staticRenderFns } from "./EditSubcategoryDetailsModal.vue?vue&type=template&id=7ff9e0b8&scoped=true&"
import script from "./EditSubcategoryDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./EditSubcategoryDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditSubcategoryDetailsModal.vue?vue&type=style&index=0&id=7ff9e0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff9e0b8",
  null
  
)

export default component.exports